<template>
  <div class="form">
    <el-row :gutter="20">
      <el-table
        :data="tableData"
        style="width: 100%">
          <el-table-column
            prop="id"
            label="id"
            width="90">
          </el-table-column>
          <el-table-column
            prop="office_name"
            :label="$t('formLabel.office_name')">
          </el-table-column>
          <el-table-column
            prop="contact_name"
            :label="$t('formLabel.contact_name')">
          </el-table-column>
          <el-table-column
            prop="contact_email"
            :label="$t('formLabel.contact_email')">
          </el-table-column>
          <el-table-column
            prop="contact_phone"
            :label="$t('formLabel.contact_phone')">
          </el-table-column>
          <el-table-column
            prop="industry"
            :label="$t('formLabel.industry')">
          </el-table-column>
          <el-table-column
            :label="$t('formLabel.requirement')"
            min-width="100">
            <template slot-scope="scope">
              <div class="leading-normal" v-html="textLimit(scope)" @click="moreDetail(scope)"></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            :label="$t('formLabel.created_at')"
            :formatter="timeFormat"
            width="180">
          </el-table-column>
          <el-table-column label="操作"
            prop="status"
            width="90"
            :filters="[{ text: '未讀', value: 'unread' }, { text: '已解決', value: 'solve' }, { text: '已刪除', value: 'delete' }]"
            :filter-method="filterStatus">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                @click="changeStatus(scope.$index, scope.row)"
                :type="statusColor(scope.row.status)"
                class="cursor-pointer"
                plain>{{ $t('status.' + scope.row.status) }}</el-tag>
            </template>
          </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import _ from 'lodash'
import dayjs from 'dayjs'
import ADMIN from '@/api/admin.js'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      tableData: null
    }
  },
  computed: {
    ...mapGetters([
      'token',
      'user'
    ])
  },
  methods: {
    filterStatus (value, row) {
      return row.status === value
    },
    statusColor: function (status) {
      const bgColor = {
        unread: 'warning',
        read: 'success',
        solve: 'success',
        update: 'warning',
        delete: 'danger'
      }
      return bgColor[status]
    },
    changeStatus: function (index, row) {
      const id = row.id
      ADMIN.updateFormStatus(id, row).then(res => {
        console.log(res.data)
        this.tableData[index].status = res.data.status
      })
    },
    textLimit: function (scope) {
      let str = scope.row.requirement
      if (str.length > 100) {
        str = str.substring(0, 100) + ' ...'
      }
      return str
    },
    moreDetail: function (scope) {
      let str = scope.row.requirement
      if (str.length > 100) {
        this.$msgbox({
          title: this.$t('formLabel.requirement'),
          message: scope.row.requirement,
          customClass: 'msgBox'
        })
      }
    },
    getForm: function () {
      ADMIN.getForm().then(res => {
        // this.tableData = _.chain(res.data).filter( (o) => { return o.status !== 'delete'} ).reverse(['created_at']).value()
        this.tableData = _.chain(res.data).reverse(['created_at']).value()
      })
    },
    timeFormat: function (row, column) {
      return dayjs(row[column.property]).format('YYYY-MM-DD')
    }
  },
  mounted () {
    if (this.token) {
      this.getForm()
    }
  }
}
</script>

<style lang="sass">
.msgBox
  p
    @apply text-grey-dark leading-normal
</style>
